export const GET_PUBLICOFFERS_DATA = 'GET_PUBLICOFFERS_DATA'
export const TOOGLE_GENERALCONDITIONS = 'TOOGLE_GENERALCONDITIONS'
export const TOOGLE_PUBLICOFFERS = 'TOOGLE_PUBLICOFFERS'
export const SET_ISLOADING = 'SET_ISLOADING'
export const RESET_OFFERS_TO_SEND = 'RESET_OFFERS_TO_SEND'
